import Vue from 'vue';
import NoLayout from '@/views/layouts/nolayout/';
import DefaultLayout from '@/views/layouts/default/';

Vue.component('DefaultLayout', DefaultLayout);
Vue.component('NoLayout', NoLayout);
